import {atom, selectorFamily} from 'recoil';
import {ToastHelpers} from '../../../shared/helpers/toastHelpers';
import {serialize} from '../../../shared/utils/serialize-query-params';
import {api} from '../../api';
import {createQuery} from '../../lib';

const {getDictsServiceTypes} = api.dicts;

const getDictsServiceTypesRefresh = atom<number>({
  key: 'getDictsServiceTypesRefresh',
  default: 0,
});

const getDictsServiceTypesQuery = selectorFamily({
  key: 'getDictsServiceTypes',
  get(params: Parameters<typeof getDictsServiceTypes>[0]) {
    return async ({get}) => {
      get(getDictsServiceTypesRefresh);
      try {
        const {data} = await getDictsServiceTypes(params, {paramsSerializer: {serialize}});
        return data;
      } catch (e) {
        ToastHelpers.error(e);
        throw e;
      }
    };
  },
});

export const useGetDictsServiceTypesQuery = createQuery(getDictsServiceTypesQuery, getDictsServiceTypesRefresh);
